import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { fetchTemplates } from "../../../actions/roblox/templatesActions";
import { useAppDispatch } from "../../../store/hooks";
import { queryParams } from "../../../helpers/UrlHelpers";
import robloxUrls from "../../../configs/roblox/robloxUrls";
import { setNewParams } from "../../../store/roblox/templatesSlice";

import PageLayout from "../_partials/PageLayout";
import PageHeader from "./_partials/_PageHeader";
import List from "./_partials/_List";
import Wrapper from "../../../componets/Wrapper";
import Filter, { FilterInterface } from "../../../componets/Filter";
import NavBarThree from "../../../componets/NavBarThree";
import { PlusOutlined } from "@ant-design/icons";
import New from "./New";
import ListViewButtons from "../../../componets/ListViewButtons";

interface PropsInterface {
  collection?: 'pants' | 'shirts' | 't_shirts' | 'posts';
}

const NAV_ITEMS: {[index: number]: any} = {
  0: {
    id: 0,
    name: 'Pants',
    url: robloxUrls.templatesPantsPath()
  },
  1: {
    id: 1,
    name: 'Shirts',
    url: robloxUrls.templatesShirtsPath()
  },
  2: {
    id: 2,
    name: 'T-shirts',
    url: robloxUrls.templatesTshirtsPath()
  }
};
const LIMIT = 42;
const DEFAULT_VIEW = 'grid';
const TYPES = { pants: 0, shirts: 1, t_shirts: 2 };

const Templates = ({ collection }: PropsInterface) => {
  const dispatch  = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const listType: any = queryParams.get(searchParams,'view') || DEFAULT_VIEW;
  const filterProps: FilterInterface = {};

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit: LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    if (collection) {
      params.type_id = TYPES[collection];
    }

    dispatch(fetchTemplates({ params }));
  }, [collection, searchParams, currentPage, dispatch]);

  function onClickCreate() {
    dispatch(setNewParams({ type_id: TYPES[collection || 'pants'], coins: 0, premium: false }));
  }

  filterProps.orderBy = {
    defaultKey: 'id',
    defaultSort: 'desc',
    items: [
      { name: 'Date', key: 'id' }
    ]
  };

  return (
    <PageLayout>
      <PageHeader
        title={'Templates'}
        navs={NAV_ITEMS}
        parent={{
          name: 'All',
          url: robloxUrls.templatesPath()
        }}
      />

      <Wrapper>
        <NavBarThree>
          <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
            <PlusOutlined /> Create Template
          </NavBarThree.Button>
        </NavBarThree>
      </Wrapper>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            dateRange
            {...filterProps}
          >
            <ListViewButtons className='v-mb-5' align='right' defaultType={DEFAULT_VIEW} />
          </Filter>
        </Wrapper>

        <List limit={LIMIT} pagination={true} type={listType} />

        <New />
      </div>
    </PageLayout>
  );
}

export default Templates;
